export const IMAGE_SIZE_OPTIONS = {
  slim: {
    padding: 56,
    full: 80
  },
  standard: {
    padding: 80,
    full: 104
  },
  compact: {
    padding: 56,
    full: 80
  }
};
